import { isMultiAccountScenario } from './isMultiAccountScenario';
import { isCloudCacheScenario } from './isCloudCacheScenario';

export function isLeftRailVisible() {
    return isCloudCacheScenario() || isMultiAccountScenario();
}
